<div #container>
  <h3 class="title">{{ getTitleKey() | translate }}</h3>
  <highcharts-chart
    [Highcharts]="highCharts"
    [constructorType]="'stockChart'"
    [options]="chartOptions"
    (chartInstance)="setChartInstance($event)"
  ></highcharts-chart>
  <div class="legend-features-wrapper">
    <ng-container *ngFor="let series of chartSeries">
      <div
        class="legend-feature"
        [class.legend-feature--hidden]="!series.visible"
        (click)="changeChartVisibility(series.name)"
      >
        <span class="legend-feature-indicator" [style.background-color]="series.color"></span>
        <div
          class="legend-feature-description"
          [matTooltip]="series.name"
          matTooltipPosition="above"
          #tooltipElement
          [matTooltipDisabled]="isTooltipDisabled(tooltipElement)"
        >
          {{ series.name }}
        </div>
      </div>
    </ng-container>
  </div>
</div>
